import { IMatchForm } from '@/types/match.d';
import fetch from './index';

// ------------------ MATCH-INFO 课程信息
// 获取赛事信息
const getMList = (params: Object) => fetch.axios_admin.get('/competition', { params });

// 创建赛事
const addMatch = (data: FormData) => fetch.axios_admin.post('/competition', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 修改赛事
const editMatch = (data: FormData) => fetch.axios_admin.put('/competition', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 终止赛事
const stopMatch = (id: string) => fetch.axios_admin.put(`/competition/end?pid=${id}`);

// 发布赛事
const releseMatch = (id: string) => fetch.axios_admin.put(`/competition/release?pid=${id}`);

// 删除赛事
const removeMatch = (id: string) => fetch.axios_admin.remove(`/competition?pid=${id}`);

// 获取所有管理员
const getManage = (n: string) => fetch.axios_admin.get(`/competition/candidate/admin?n=${n}`);

// 获取绑定管理员
const getBindManage = (id: string) => fetch.axios_admin.get(`/competition/admin?id=${id}`);

// 修改赛事内容
const editMatchContent = (params: FormData) => fetch.axios_admin.put('/competition/content', params, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 选择机构
const getOrg = () => fetch.axios_admin.get('/org/root');

// 获取机构下的教师
const getOrgteacher = (id: string, name: string) => fetch.axios_admin.get(`/competition/candidate/teacher?id=${id}&name=${name}`);

// 提交奖项
const addAwards = (id: string, params: any) => fetch.axios_admin.post(`/competition/awards?id=${id}`, params);

// 获取奖项
const getAwards = (id: string) => fetch.axios_admin.get(`/competition/awards?id=${id}`);

// 保存默认分组配置
const addGroup = (id: string, params: any) => fetch.axios_admin.post(`/competition/public/default/configuration?id=${id}`, params);

// 获取分组
const getGroup = (id: string) => fetch.axios_admin.get(`/competition/public/default/configuration?id=${id}`);

// 获取参赛工作人员
const getEmployee = (id: string) => fetch.axios_admin.get(`/competition/employee?id=${id}`);

const getUSer = (id: string, params: Object) => fetch.axios_admin.get(`/competition/user/statistic?id=${id}`, { params });

export default {
  getMList,
  addMatch,
  editMatch,
  stopMatch,
  releseMatch,
  removeMatch,
  getManage,
  getBindManage,
  editMatchContent,
  getOrg,
  getOrgteacher,
  addAwards,
  getAwards,
  addGroup,
  getGroup,
  getEmployee,
  getUSer,
};
